import React from 'react';
import type { SVGProps } from 'react';

import { createDictionary } from 'utils/ObjectUtils';

import AVI from '../../../icons/fileType/avi.svg';
import DEFAULT from '../../../icons/fileType/default.svg';
import GIF from '../../../icons/fileType/gif.svg';
import JPG from '../../../icons/fileType/jpg.svg';
import MOV from '../../../icons/fileType/mov.svg';
import MP3 from '../../../icons/fileType/mp3.svg';
import MP4 from '../../../icons/fileType/mp4.svg';
import PDF from '../../../icons/fileType/pdf.svg';
import PNG from '../../../icons/fileType/png.svg';
import PPT from '../../../icons/fileType/ppt.svg';
import RAR from '../../../icons/fileType/rar.svg';
import ROW from '../../../icons/fileType/row.svg';
import TXT from '../../../icons/fileType/txt.svg';
import WAV from '../../../icons/fileType/wav.svg';
import WORD from '../../../icons/fileType/word.svg';
import XLS from '../../../icons/fileType/xls.svg';
import ZIP from '../../../icons/fileType/zip.svg';

const FILE_TYPE_ICONS = createDictionary(
  {
    avi: AVI,
    gif: GIF,
    jpg: JPG,
    jpeg: JPG,
    mov: MOV,
    mp3: MP3,
    mp4: MP4,
    pdf: PDF,
    png: PNG,
    ppt: PPT,
    pptx: PPT,
    rar: RAR,
    row: ROW,
    txt: TXT,
    wav: WAV,
    doc: WORD,
    docx: WORD,
    xls: XLS,
    xlsx: XLS,
    csv: XLS,
    zip: ZIP
  },
  DEFAULT
);

type FileTypeIconProps = {
  extension?: string;
} & SVGProps<SVGSVGElement>;

const FileTypeIcon: React.FC<FileTypeIconProps> = ({ extension, ...rest }) => {
  const Icon = FILE_TYPE_ICONS[extension?.toLowerCase() ?? ''];
  return <Icon width="1em" height="1em" {...rest} />;
};

export default FileTypeIcon;
